import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import AlertModal from 'web/components/AlertModal';
import CloseIconBlackBg from 'web/assets/svg/CloseIconBlackBg'
import {
    invitationAccept,
    deleteNetwork,
    withdrawNetwork
} from 'redux/actions/myNetwork';
import { BoxContainer, BoxContainerHeader, ActionBtn } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";
import { ManageInvitationsWrapper, InvitationsRow } from "web/pages/private/CommonPages/MyNetworks/ManageInvitations/ManageInvitationsStyled";
const ManageInvitations = ({ networkRequests, closeIconCallBack, pageLanguageContents }) => {
    const dispatch = useDispatch();
    let history = useHistory();

    const token = localStorage.getItem('token');
    const loggedInAuthId = localStorage.getItem('authId');
    const [alertTypeState, setAlertTypeState] = useState();

    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [modalLink, setModalLink] = useState('');
    const toggleModal = () => setModal(!modal);

    const timestamp = (updatedAt) => {
        let timestamp = updatedAt
        let date = new Date(timestamp);
        return date
    }

    let arr = []
    let arrVal = []



    if (networkRequests) {
        for (let i = 0; i < networkRequests.pendingGroups.length; i++) {
            let setDate = timestamp(networkRequests.pendingGroups[i].updatedAt)
            let obj = {
                id: networkRequests.pendingGroups[i].id,
                info: networkRequests.pendingGroups[i].info,
                isGroupAdminAuthId: networkRequests.pendingGroups[i].isGroupAdminAuthId,
                type: "pendingGroups",
                networkName: networkRequests.pendingGroups[i].networkName,
                updatedAt: setDate
            }
            arrVal.push(obj)
        }
        for (let i = 0; i < networkRequests.acceptedGroups.length; i++) {
            let setDate = timestamp(networkRequests.acceptedGroups[i].updatedAt)
            let obj = {
                id: networkRequests.acceptedGroups[i].id,
                info: networkRequests.acceptedGroups[i].info,
                isGroupAdminAuthId: networkRequests.acceptedGroups[i].isGroupAdminAuthId,
                type: "acceptedGroups",
                networkName: networkRequests.acceptedGroups[i].networkName,
                updatedAt: setDate
            }
            arrVal.push(obj)
        }
        for (let i = 0; i < networkRequests.invitedGroups.length; i++) {
            let setDate = timestamp(networkRequests.invitedGroups[i].updatedAt)
            let obj = {
                id: networkRequests.invitedGroups[i].id,
                info: networkRequests.invitedGroups[i].info,
                isGroupAdminAuthId: networkRequests.invitedGroups[i].isGroupAdminAuthId,
                type: "invitedGroups",
                networkName: networkRequests.invitedGroups[i].networkName,
                updatedAt: setDate
            }
            arrVal.push(obj)
        }
    }

    useEffect(() => {
        if (!localStorage.getItem('token')) {
            history.push('/sign-in')
            window.location.reload(false);
        } else {
        }
    }, []);
    const acceptReject = async (index, memberitem, actionType) => {
        let data = {
            networkId: networkRequests.pendingGroups[index].id,
            userId: memberitem.info.userId,
            authId: memberitem.info.authId,
            memberState: actionType
        }

        let invitationResponse = await dispatch(invitationAccept(data, token));
        if (invitationResponse.status === 'SUCCESS') {
            closeIconCallBack("Accept")
            setAlertTypeState("createGroup")
            setModalContent(invitationResponse.message);
            setModalLink('');
            toggleModal();
        } else {
            if (invitationResponse.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(invitationResponse.message === 'user id can not be null' ? 'User is still not registered. Please contact Admin.' : invitationResponse.message);
                setModalLink('');
                toggleModal();
            }
        }
    }
    const declineApi = async (index, memberitem, actionType) => {
        let data = {
            networkId: networkRequests.pendingGroups[index].id,
            authId: memberitem.info.authId,
            memberState: actionType
        }

        let invitationResponse = await dispatch(deleteNetwork(memberitem.info.userId, data, token));
        if (invitationResponse.status === 'SUCCESS') {
            setAlertTypeState("createGroup")
            setModalContent(invitationResponse.message);
            setModalLink('');
            toggleModal();
        } else {
            if (invitationResponse.statusCode === 401) {
                history.push('/sign-in')
                window.location.reload(false);
            } else {
                setModalContent(invitationResponse.message);
                setModalLink('');
                toggleModal();
            }
        }
    }
    const withdrawNetworkApi = async (index, memberitem, actionType) => {
        let data;
        if (memberitem.info) {
            if (memberitem.info.userId) {
                data = {
                    networkId: memberitem.id,
                    authId: memberitem.info.authId,
                    memberState: actionType,
                    userId: memberitem.info.userId
                }
            } else {
                data = {
                    networkId: memberitem.id,
                    authId: memberitem.info.authId,
                    memberState: actionType,
                    email: memberitem.info.email
                }
            }

            let invitationResponse = await dispatch(withdrawNetwork(data, token));
            if (invitationResponse.status === 'SUCCESS') {
                setAlertTypeState("createGroup")
                setModalContent(invitationResponse.message);
                setModalLink('');
                toggleModal();
            } else {
                if (invitationResponse.statusCode === 401) {
                    history.push('/sign-in')
                    window.location.reload(false);
                } else {
                    setModalContent(invitationResponse.message);
                    setModalLink('');
                    toggleModal();
                }
            }
        } else {
            if (pageLanguageContents?.Validations) setModalContent(pageLanguageContents?.Validations[3]?.InfoNotFound)
            else setModalContent("Info object not found in API.");
            setModalLink('');
            toggleModal();
        }

    }
    return (
        <>
            <BoxContainer>
                <BoxContainerHeader>
                    <h2>
                        {pageLanguageContents?.ManageInvitations[0]?.ManageInvitations}
                    </h2>
                    <CloseIconBlackBg onClick={() => {
                        closeIconCallBack('Back')
                    }} />

                </BoxContainerHeader>
                <ManageInvitationsWrapper>
                    {arrVal.map((memberitem, index) => (<>
                        {memberitem.type === "pendingGroups" && <InvitationsRow>
                            {memberitem.info && memberitem.info.invitedByAuthId !== null ?
                                <h3>
                                    {memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email} has requested to join the group {memberitem.networkName}
                                </h3>
                                :
                                <h3>{memberitem.info && memberitem.info.invitedUserName} {pageLanguageContents?.ManageInvitations[1]?.GroupInvitation} {memberitem.networkName}</h3>
                            }
                            <div className='action-btn'>
                                <button className='active' onClick={() => {
                                    declineApi(index, memberitem, "DECLINED")
                                }}>{pageLanguageContents?.ManageInvitations[2]?.Decline}</button>
                                <button className='active' onClick={() => {
                                    acceptReject(index, memberitem, "ACCEPTED")
                                }}>{pageLanguageContents?.ManageInvitations[3]?.Accept}</button>
                            </div>
                        </InvitationsRow>}

                        {memberitem.type === "acceptedGroups" && <InvitationsRow>
                            {
                                memberitem.info && memberitem.info.withoutReviewJoinedGroup === true ?
                                    <>
                                        <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email} has joined the group {memberitem.networkName}
                                        </h3>
                                    </>
                                    :
                                    <>
                                        {memberitem.info && memberitem.info.requestToJoin === true && memberitem.info.invitedUserName !== 'You' ?
                                            <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email} has accepted the request to join the group {memberitem.networkName}
                                            </h3>
                                            :
                                            <>
                                                {memberitem.info && memberitem.info.invitedUserName === 'You' ?
                                                    <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email}
                                                        {pageLanguageContents?.ManageInvitations[8]?.InvitationAcceptance}
                                                        {memberitem.networkName}
                                                    </h3>
                                                    :
                                                    <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email}
                                                        {pageLanguageContents?.ManageInvitations[12]?.HasAccepted}
                                                        {memberitem.info.invitedUserName}'{pageLanguageContents?.ManageInvitations[13]?.InvitationToJoin}
                                                        {memberitem.networkName}
                                                    </h3>
                                                }
                                            </>
                                        }
                                    </>
                            }
                        </InvitationsRow>}

                        {memberitem.type === "invitedGroups" && <InvitationsRow>
                            {
                                memberitem.info && memberitem.info.memberState === "DECLINED" ?
                                    <>
                                        {memberitem.info.declinedRequest === true ?
                                            <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email} has declined your request to join the group {memberitem.networkName}</h3>
                                            :
                                            <>
                                                {memberitem.info && memberitem.info.invitedUserName === 'You' ?
                                                    <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email}
                                                        {pageLanguageContents?.ManageInvitations[14]?.DeclinedInvitation}
                                                        {memberitem.networkName}
                                                    </h3>
                                                    :
                                                    <h3>{memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email} has declined the request to join the group {memberitem.networkName}</h3>
                                                }
                                            </>
                                        }
                                    </>
                                    :
                                    <>
                                        {memberitem.info && memberitem.info.invitedByAuthId !== null ?
                                            <h3>
                                                You have requested to join the group {memberitem.networkName}
                                            </h3>
                                            :
                                            <h3>{memberitem.info && memberitem.info.invitedUserName}
                                                {memberitem.info.invitedUserName === 'You' ? pageLanguageContents?.ManageInvitations[11]?.HaveInvited : pageLanguageContents?.ManageInvitations[10]?.HasInvited}
                                                {memberitem.info && memberitem.info.name ? memberitem.info.name : memberitem.info.email}
                                                {pageLanguageContents?.ManageInvitations[5]?.ToGroup}
                                                {memberitem.networkName}
                                            </h3>
                                        }
                                        <div className='action-btn'>
                                            {memberitem.isGroupAdminAuthId && memberitem.isGroupAdminAuthId.includes(loggedInAuthId) && memberitem?.info?.memberState !== "PENDING" && <button className={memberitem.isGroupAdminAuthId && memberitem.isGroupAdminAuthId.includes(loggedInAuthId) ? 'active' : 'pending'}
                                                disabled={memberitem.isGroupAdminAuthId && memberitem.isGroupAdminAuthId.includes(loggedInAuthId) ? false : true}
                                                onClick={() => {
                                                    withdrawNetworkApi(index, memberitem, "DECLINED")
                                                }}>{pageLanguageContents?.ManageInvitations[6]?.Withdraw}</button>}

                                            {memberitem?.info?.memberState === "PENDING" && <button className={'active'}

                                                onClick={() => {
                                                    withdrawNetworkApi(index, memberitem, "DECLINED")
                                                }}>{pageLanguageContents?.ManageInvitations[6]?.Withdraw}</button>}
                                            <button className='pending'>{pageLanguageContents?.ManageInvitations[7]?.Pending}</button>
                                        </div>
                                    </>
                            }
                        </InvitationsRow>}
                    </>
                    ))}
                </ManageInvitationsWrapper>

                <ActionBtn>
                    <button onClick={() => {
                        closeIconCallBack("Back")
                    }}>
                        {pageLanguageContents?.ManageInvitations[9]?.Back}
                    </button>
                </ActionBtn>
            </BoxContainer>
            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=""
                content={modalContent}
                link={modalLink}
                alertType={alertTypeState}
                callBackAlert={(val) => {
                    if (val === "createGroup")
                        closeIconCallBack()
                }}
            />
        </>
    );
}



export default ManageInvitations;
